// extracted by mini-css-extract-plugin
module.exports = {"description":"BasicContentAccordion_description__5GifO","search-fade-in":"BasicContentAccordion_search-fade-in__KAaAq"};